import { memo } from 'react'

export interface ErrorProps {
  onRetry: () => void
}

const Error = memo(({ onRetry }: ErrorProps) => (
  <div className="fts-error">
    <p>Der Digitale Kontoauszug konnte leider nicht geladen werden.</p>
    <button type="button" onClick={() => onRetry()}>
      Erneut versuchen
    </button>
  </div>
))

Error.displayName = 'Error'

export { Error }
